
import { MailSettings } from "@/models/mail-settings";
import Vue from "vue";
import { TranslateResult } from "vue-i18n";

export default Vue.extend({
	data(){
		return {
			value: ""
		};
	},
	props: {
		settings: {
			type: Object as ()=>MailSettings,
			required: true
		}
	},
	computed: {
		title():TranslateResult{
			if (this.settings.ID == 0){
				return this.$ct("add-mail-settings");
			}
			return this.$ct("rename-mail-settings", {name: this.settings.Label});
		},
		inputLabel():TranslateResult{
			return this.$ct("mail-settings-new-name");
		},
		confirmDisabled():boolean {
			return this.settings.Label.trim() == "";
		},
	},
	watch: {
		settings: {
			immediate: true,
			handler(){
				this.value = this.settings.Label;
			}
		}
	},
	methods: {
		close(){
			this.$emit("close");
		},
		confirm(){
			this.$emit("confirm", this.value);
			this.close();
		}
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
